const contentBanner = () => import("@/pages/content/banner/index.vue");
const contentBannerForm = () => import("@/pages/content/banner/form.vue");

export default [
    {
        path: "/content/banner",
        component: contentBanner,
        meta: [
            {
                name: "内容管理",
                activeRoute: "/content/manage",
            },
            {
                name: "banner管理",
                activeRoute: "/content/banner",
            },
        ],
    },
    {
        path: "/content/banner/form",
        component: contentBannerForm,
        meta: [
            {
                name: "内容管理",
                activeRoute: "/content/manage",
            },
            {
                name: "banner管理",
                url: "/content/banner",
            },
            {
                name: "新增/编辑",
                activeRoute: "/content/banner",
            },
        ],
    },
];
